// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","expandableSection":"G6e1937","expandedContent":"Gc07bae","ctaContainer":"Ge1e8df"};